import { Reveal } from "@/components/Reveal";

const REVIEWS = [
  {
    quote: "It is SOOOO COOOOOOL, can't wait to click pictures in it",
    name: "IDITRI GOEL",
    card: "bg-paper text-ink",
    tilt: "-rotate-2",
    offset: "lg:translate-y-0",
  },
  {
    quote: "Loved the Teeeee",
    name: "SILKY MAKKAR",
    card: "bg-pink text-black",
    tilt: "rotate-1",
    offset: "lg:translate-y-10",
  },
  {
    quote: "Loved the packaging! It is so sick!",
    name: "PRINCE RAI",
    card: "bg-acid text-black",
    tilt: "-rotate-1",
    offset: "lg:translate-y-4",
  },
  {
    quote: "What a lovely piece of art!",
    name: "SAALIM SHAMSI",
    card: "bg-paper text-ink",
    tilt: "rotate-2",
    offset: "lg:translate-y-12",
  },
  {
    quote: "I am glad I own a shutup merch now! YAYAYA!",
    name: "AISHWARYA KUKRETI",
    card: "bg-turq text-black",
    tilt: "-rotate-2",
    offset: "lg:translate-y-6",
  },
];

export default function Reviews() {
  return (
    <section data-testid="reviews-section" className="bg-black text-paper py-24 sm:py-32 overflow-hidden">
      <div className="mx-auto max-w-7xl px-5 sm:px-10">
        <Reveal>
          <p className="font-sans text-turq text-xs font-semibold tracking-[0.35em] mb-6">INTERLUDE — WORD ON THE STREET</p>
          <h2
            className="font-display leading-[0.9] text-[clamp(2.8rem,9vw,7.5rem)]"
            data-testid="reviews-title"
          >
            THEY DIDN'T <span className="text-pink">SHUT UP.</span>
          </h2>
        </Reveal>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 mt-14 sm:mt-20" data-testid="reviews-wall">
          {REVIEWS.map((r, i) => (
            <Reveal key={r.name} delay={0.08 * i} className={r.offset}>
              <figure
                data-testid={`review-card-${i + 1}`}
                className={`${r.card} ${r.tilt} p-6 sm:p-8 border-2 border-black shadow-[8px_8px_0_rgba(255,255,255,0.12)] hover:rotate-0 hover:scale-[1.02] transition-transform duration-300`}
              >
                <blockquote className="font-hand text-3xl sm:text-4xl leading-tight">
                  “{r.quote}”
                </blockquote>
                <figcaption
                  className="font-sans font-bold text-xs tracking-[0.3em] mt-6"
                  data-testid={`review-name-${i + 1}`}
                >
                  — {r.name}
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2}>
          <p className="font-hand text-2xl text-paper/60 mt-14 -rotate-1" data-testid="reviews-note">
            real words from real rebels. nothing invented.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
